// @flow
import {
  actionTypes,
} from 'chronos-actions';

import type {
  Action,
  FilterState,
} from 'chronos-types';


const initialState = {
  filterType: 'users',
  users: [],
  projects: [],
  boards: [],
  versions: [],
  issueTypes: [],
  issueStatuses: [],
  epics: [],
  sprints: [],
  worklogTypes: [],
  components: [],
  jqlFilters: [],
};

const filters = (
  state: FilterState = initialState,
  action: Action,
) => {
  switch (action.type) {
    case actionTypes.ADD_FILTER:
      return {
        ...state,
        [action.filterType]: [
          action.filterValue,
          ...state[action.filterType],
        ],
      };
    case actionTypes.REMOVE_FILTER: {
      const {
        filterValue,
        filterType,
      } = action;
      return {
        ...state,
        [filterType]:
          [...state[filterType]
            .filter(i => i !== filterValue)],
      };
    }
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        ...action.values,
      };
    case actionTypes.SET_FILTER:
      return {
        ...state,
        [action.filterType]: (
          action.filterValue
        ),
      };
    case actionTypes.SET_FILTER_TYPE:
      return {
        ...state,
        filterType: action.filterType,
      };
    default:
      return state;
  }
};

export default filters;
